import { render, staticRenderFns } from "./setDeptDrawer.vue?vue&type=template&id=0390a45a&scoped=true"
import script from "./setDeptDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./setDeptDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./setDeptDrawer.vue?vue&type=style&index=0&id=0390a45a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0390a45a",
  null
  
)

export default component.exports